import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Protected route component that checks authentication
const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (isLoading) {
    return <div className="spinner"></div>;
  }

  // If authenticated, render the child routes (outlet)
  // If not, redirect to login and remember where they were trying to go
  return isAuthenticated ?
    <Outlet /> :
    <Navigate to="/login" state={{ from: location }} replace />;
};

export default ProtectedRoute;
